export default {
  name: 'Locations',
  data() {
    return {};
  },
};
